import { COLORS, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const CouponsCTAWrapper = styled.div<{ $isDashboardScreen: boolean }>`
  grid-column: 1 / span 2;
  margin: ${({ $isDashboardScreen }) => ($isDashboardScreen ? '12px 0 0 0 ' : ' 5px 20px 0 0')};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  line-height: 22px;
  color: ${COLORS.textGrey};
  background-color: rgba(72, 250, 255, 0.1);
  border: 1px solid rgba(72, 250, 255, 0.4);
  border-radius: 4px;
  padding: 6px 12px;
  .bold-text {
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .small-text {
    font-weight: 400;
  }

  .successWrapper {
    display: flex;
    flex-direction: row;

    .left-column {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 50%;

      .hand-image {
        margin-right: 6px;
        width: 24px;
        height: 24px;
      }
    }

    .right-column {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      text-align: right;
      width: 50%;
    }

    .breakup-container {
      padding-top: 5px;
    }
  }
`;
